import { formatTicker } from '@api';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { Filter, FilterProps } from '@terminal/components/filter/Filter';
import { FilterOption } from '@terminal/components/update-filter-options/updateFilterOptions';
import { FilterGroupKeys } from '@terminal/hooks/use-filter-actions/useFilterActions';
import React from 'react';

import styles from './FilterCompany.module.scss';

export const FilterCompany = <T extends FilterGroupKeys>({
  labels,
  ...rest
}: FilterProps<T>) => {
  const renderCustomFilterOptionLabel = (filterOption: FilterOption) => {
    if (filterOption?.entity) {
      const entity = filterOption.entity;
      const tag = formatTicker(entity);
      return (
        <div className={styles.flexRow}>
          <AssetLogoContainer entity={entity} size={20} />
          <div className={styles.flexColumn}>
            <div className={styles.title}>{tag}</div>
            <div className={styles.subtitle}>{entity.name}</div>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <Filter labels={{ ...labels, renderCustomFilterOptionLabel }} {...rest} />
  );
};
